export const TOKEN_KEY = '__token';
export const USER_KEY = '__user';
export const COOKIE_OPTION = { expires: 9999, path: '/' };

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
